export const isTokenValidSelector = (state) => state.main.isTokenValid
